import { PartPair } from '@inter-ikea-core/core';
import { CoreApi, Product, ProductType } from '@inter-ikea-storageone/range';

import { addInteriorSuggestionEntityToFrame } from 'rangeConfig/shared/utils/interiorSuggestions';

export const addInteriorSuggestionToPaxFrame = (
  interiorSuggestionProductId: string,
  products: Product[],
  menu: string,
  coreApi: CoreApi
) => {
  const interiorSuggestionProduct = products.find(
    product => product.coreProductId === interiorSuggestionProductId
  );

  if (!interiorSuggestionProduct) return;

  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) return;

  let interiorSuggestionEntity;

  const placedInCornerSolution = coreApi.entities.isProductType(
    selectedEntity,
    ProductType.PAX_CORNER_SOLUTION_ASM
  );

  const boxes = [
    ProductType.PAX_SKUBB_STORAGE_CASES,
    ProductType.PAX_HEMMAFIXARE_STORAGE_CASE,
    ProductType.PAX_SKUBB_STORAGE_BOXES,
    ProductType.PAX_SKUBB_STORAGE_BOXES_W_COMP,
    ProductType.PAX_SKUBB_STORAGE_CASE_WRAP
  ];

  const productDTO = coreApi
    .getInteriorSuggestionProductCatalog()
    ?.findProductDTO(interiorSuggestionProduct.coreProductId);

  // Replace any skubb/hemmafixare box in interior suggestion if placed in corner solution
  if (placedInCornerSolution && productDTO && productDTO.template.parts) {
    const replaceParts = productDTO.template.parts
      .map(part => {
        const partProduct = products.find(p => p.coreProductId === part.id);
        if (!partProduct) return undefined;

        if (boxes.includes(partProduct.type)) {
          return new PartPair(part.partKey, '');
        }
        return undefined;
      })
      .filter((p): p is PartPair => p !== undefined);

    interiorSuggestionEntity = coreApi
      .getInteriorSuggestionProductCatalog()
      ?.createCustomAssembly(
        interiorSuggestionProduct.coreProductId,
        replaceParts,
        coreApi.getServices().productManager
      );
  } else {
    interiorSuggestionEntity = coreApi
      .getServices()
      .productManager.createEntity(interiorSuggestionProduct.coreProductId);
  }

  if (!interiorSuggestionEntity) return;

  return addInteriorSuggestionEntityToFrame(interiorSuggestionEntity, selectedEntity, coreApi);
};
